import React, { useState } from "react";
import { ChevronLeft, ChevronRight, ArrowUpRight } from "lucide-react";
import { testimonials } from "../../data/testimonialsData";
import testimonial1 from "../../assets/img/testimonials/testimonial1.png";
import testimonial2 from "../../assets/img/testimonials/testimonial2.png";
import testimonial3 from "../../assets/img/testimonials/testimonial3.png";

const TestimonialsSection = ({ title, subtitle }) => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  // Map images since they must be imported in Next.js/React professional setup
  const testimonialImages = [testimonial1, testimonial2, testimonial3];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <>
      <section className="testimonials-section">
        <div className="testimonials-header">
          <h2 className="testimonials-title">
            {title || (
              <><span className="text-primary">Valued feedback from</span> our clients</>
            )}
          </h2>
          <p className="testimonials-subtitle">
            {subtitle || (
              <>
                Don't just take our word for it, hear the experiences of our
                clients. As a leading custom software development
                <br />
                company, we make sure our clients receive the best products and it
                is precisely delivered to the founder's vision.
              </>
            )}
          </p>
        </div>

        <div className="testimonial-card">
          <div
            className="testimonial-image-col"
            onClick={() => setIsVideoModalOpen(true)}
            style={{ cursor: "pointer" }}
            title="Play Video"
          >
            <img
              src={testimonialImages[currentTestimonial].src || testimonialImages[currentTestimonial]}
              alt={testimonials[currentTestimonial].authorName}
              className="testimonial-image"
            />
            <div className="testimonial-icon-yt">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="red">
                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
              </svg>
            </div>
          </div>
          <div className="testimonial-content-col">
            <span className="testimonial-quote-icon">“</span>
            <p className="testimonial-text">
              {testimonials[currentTestimonial].text}
            </p>
            <div>
              <h4 className="testimonial-author-name">{testimonials[currentTestimonial].authorName}</h4>
              <p className="testimonial-author-title">
                {testimonials[currentTestimonial].authorTitle}
              </p>
            </div>

            <div className="testimonial-controls">
              <button className="testimonial-control" onClick={prevTestimonial}>
                <ChevronLeft size={16} />
              </button>
              <button className="testimonial-control" onClick={nextTestimonial}>
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        </div>

        <div className="testimonials-footer">
          <a href="#" className="testimonials-link">
            View All Testimonials <ArrowUpRight size={16} />
          </a>
        </div>
      </section>

      {isVideoModalOpen && (
        <div className="video-modal-overlay" onClick={() => setIsVideoModalOpen(false)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={() => setIsVideoModalOpen(false)} title="Close">
              &times;
            </button>
            <div className="video-modal-iframe-wrapper">
              <iframe
                width="100%"
                height="100%"
                src={testimonials[currentTestimonial].videoEmbedUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TestimonialsSection;
